(function () {
  var CREW = ['GENERALPATTON', 'BACKYARDBUSHCRAFT', 'PROCALIBERHQ', 'BURNWOOD', 'M32OUTDOORS'];
  var code = null;

  function fromParam() {
    try { return new URLSearchParams(location.search).get('crew'); } catch (e) { return null; }
  }
  function fromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function fromStore() {
    try { return sessionStorage.getItem('as_crew'); } catch (e) { return null; }
  }

  code = fromParam() || fromCookie() || fromStore();
  if (code) code = String(code).trim().toUpperCase();
  if (!code || CREW.indexOf(code) === -1) return;
  try { sessionStorage.setItem('as_crew', code); } catch (e) {}

  function paint() {
    var bar = document.getElementById('crew-bar');
    var slot = document.getElementById('crew-code');
    if (!bar || !slot) return;
    slot.textContent = code;
    bar.style.display = 'flex';
    var links = document.querySelectorAll('a[href*="/checkout"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].href.indexOf('discount=') === -1) {
        links[i].href += (links[i].href.indexOf('?') === -1 ? '?' : '&') + 'discount=' + code;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();
